import React from 'react';
import { LinkButton, Row, Col } from 'seduo-ui';
export default class Example extends React.Component {
    render() {
        return (<Row>
                <Col md={1}>
                    <LinkButton onClick={() => undefined}>link</LinkButton>
                </Col>
            </Row>);
    }
}
